import { render, staticRenderFns } from "./PointPayDialog.vue?vue&type=template&id=898ba67c"
import script from "./PointPayDialog.vue?vue&type=script&lang=js"
export * from "./PointPayDialog.vue?vue&type=script&lang=js"
import style0 from "./PointPayDialog.vue?vue&type=style&index=0&id=898ba67c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports